var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmMaestroBlackWhite = function SvgPmMaestroBlackWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.111 6.002H1.89C.846 6.002 0 6.822 0 7.835V26.17c0 1.012.846 1.833 1.889 1.833H32.11c1.043 0 1.889-.82 1.889-1.833V7.835c0-1.012-.846-1.833-1.889-1.833Z",
    fill: "#08031D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.803 22.205h-.048v-.283h.07l.092.199.078-.2h.069v.282h-.048v-.212l-.075.183h-.056l-.082-.183v.214Zm-.207 0h-.04v-.234h-.097v-.05h.241v.05h-.104v.233ZM13.866 17.1a7.723 7.723 0 0 1 2.75-5.985 7.076 7.076 0 0 0-9.868.819 7.86 7.86 0 0 0 0 10.331 7.076 7.076 0 0 0 9.868.819 7.723 7.723 0 0 1-2.75-5.984ZM28.414 17.1a7.65 7.65 0 0 1-4.106 6.842 7.046 7.046 0 0 1-7.691-.857A7.84 7.84 0 0 0 17.84 12.4a7.318 7.318 0 0 0-1.223-1.285 7.045 7.045 0 0 1 7.691-.858 7.65 7.65 0 0 1 4.106 6.842Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.571 13.8a7.723 7.723 0 0 0-.705 3.3 7.722 7.722 0 0 0 2.75 5.985A7.84 7.84 0 0 0 17.84 12.4a7.323 7.323 0 0 0-1.224-1.285 7.722 7.722 0 0 0-2.045 2.685Z",
    fill: "#fff",
    stroke: "#08031D"
  })));
};
export default SvgPmMaestroBlackWhite;